﻿var signal, session, localAccount, sessionEmitter;
var appid = '763f9eee00fd4ca9a056e3135593c66d';
var Artificial = false;
var domain = document.domain
var EventEmitter, IEVersion= function () {
    var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
    var isIE = userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
    // var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf("rv:11.0") > -1;
    if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion == 7) {
            return 7;
        } else if (fIEVersion == 8) {
            return 8;
        } else if (fIEVersion == 9) {
            return 9;
        } else if (fIEVersion == 10) {
            return 10;
        } else {
            return 6;//IE版本<=7
        }
    }else if (isIE11) {
        return 11; //IE11
    } else {
        return -1;//不是ie浏览器
    }
};
if(IEVersion() == -1){
    EventEmitter = require('events');
}
var alert = require('./evaluateAlert');
module.exports = san.defineComponent({
    template: require('../views/ask.html'),
    initData: function () {
        return {
            listType: 1,
            businessType: -1,
            question: '',
            dialogWait: false,
            cont: -1,
            asks: [],
            hotQuestionList: [],
            touch: false,
            open: false,
            showAlert: false,
            showEvaluate: false,
            keyword: '',
            logId:'',
            headerTip: {},
            keywordMap: {},
            ifArtificial: false,
            account: '宁夏',
            _uid: '',
            Artificial:false,
            IEVersion:-1
        };
    },
    components: {
        'alert': alert,
    },
    messages:{
        sureBtn: function (req) {
            var me = this;
            this.data.set('showEvaluate',false);
            Api("post","/api/ask/v2/evaluate",JSON.stringify(req.value)).then(function(response){
                me.data.get('asks').forEach(function(item, index){
                    if(item.logId==me.data.get('logId')){
                        me.data.set('asks['+index+'].evaluateState', 5);
                    }
                })
            })
        },
        cancel: function() {
            this.data.set('showEvaluate',false);
        }
    },
    created: function () {

    },
    goElv: function(id){
        this.data.set('logId',id);
        this.data.set('showEvaluate',true);
    },
    init: function(t){
        var me = this;
        setTimeout(function () {
        san.nextTick(function () {
            me.initType(me.data.get('businessType'),1);
        });
        }, 100);
        this.saveInfo(0, 'SEE');
        this.data.set('IEVersion',IEVersion());
        if(this.data.get('IEVersion') == -1){
            this.checkType();
            localAccount = JSON.stringify(new Date().getTime());
            sessionEmitter = new EventEmitter();
        }
    },
    checkType: function(){
        var me=this;
        $.ajax({
            url: "/static/bgImage.json",
            dataType : 'json',
            success: function(resp){
                resp.forEach(function (item) {
                    if(item.domain==document.domain){
                        me.data.set('Artificial', item.Artificial);
                        Artificial = item.Artificial;
                        if(item.Artificial){
                            me.getAppid();
                        }
                    }
                })
            },
            error: function(err) {

            }
        });
    },
    getAppid: function() {
        var me = this;
        $.ajax({
            url: "/api/agorakey/appId",
            type: "post",
            data: null,
            success: function(response) {
                appid = JSON.parse(response).appId;
                if(me.data.get('IEVersion') == -1){
                    signal = Signal(appid);
                }
            },
            error: function(err) {

            }
        });
    },
    login: function(account, token) {
        token = '_no_need_token';
        if (!appid) {
           return
        }
        var me = this;
        session = signal.login(account, token);
        return new Promise(function(resolve, reject) {
            // Proxy callback on session to sessionEmitter
            [
                'onLoginSuccess',
                'onError',
                'onLoginFailed',
                'onLogout',
                'onMessageInstantReceive',
                'onInviteReceived'
            ].map(function (event) {
                return (session[event] = function(args1, args2, args3) {
                    sessionEmitter.emit(event, args1, args2, args3);
                });
            });
            // Promise.then
            sessionEmitter.on('onLoginSuccess', function (uid) {
                me._uid = uid;
            });
            // Promise.catch
            sessionEmitter.on('onLoginFailed', function (ecode) {
            });
            sessionEmitter.on('onError', function (ecode) {
            });
            sessionEmitter.on('onLogout', function (reason) {
            });
            sessionEmitter.on('onMessageInstantReceive', function (account, uid, msg) {
                var ask = {
                    answer: msg,
                };
                me.data.set('cont', me.data.get('cont') + 1);
                var index = me.data.get('cont');
                me.data.set('asks[' + index + ']', ask);
                me.smoothScroll2LastQ();
            });
        });
    },
    logout: function() {
        return new Promise(function(resolve, reject) {
            session.logout();
            sessionEmitter.removeAllListeners();
        });
    },
    sendMessage: function(peerAccount, text) {
        if(!!session.messageInstantSend){
            session.messageInstantSend(peerAccount, text);
        }else {
            this.login(localAccount);
            sessionEmitter.once('onLoginSuccess', function (uid) {
                session.messageInstantSend(peerAccount, text);
            });
        }
    },
    initType: function (t,i) {
        this.data.set('asks', []);
        this.data.set('cont', -1);
        this.data.set('hotQuestionList', []);
        this.data.set('question', '');
        this.data.set('businessType', t);
        if(i == 2){
            this.data.set('Artificial', Artificial);
        }
        var me = this;
		Api("post","/api/common/v2/getWordConf").then(function(response){
            if (response) {
                me.data.set('headerTip', response);
            }
        });
        Api("post","/api/ask/v2/hot",JSON.stringify({businessType: t})).then(function(response){
            if (response) {
                me.data.set('hotQuestionList' , response.data.slice(0, 5));
            }
        });
    },
    saveInfo: function (t, c) {
        var visitModelDetailId, visitModelDetailName;
        switch (t) {
            case -1:
                visitModelDetailId = "SMART_CONSULT-ALL";
                visitModelDetailName = "法律机器人问答-所有";
                break;
            case 0:
                visitModelDetailId = "SMART_CONSULT";
                visitModelDetailName = "法律机器人问答";
                break;
            case 1:
                visitModelDetailId = "SMART_CONSULT-TRAFFIC";
                visitModelDetailName = "法律机器人问答-交通事故";
                break;
            case 2:
                visitModelDetailId = "SMART_CONSULT-MARRIAGE";
                visitModelDetailName = "法律机器人问答-婚姻家庭";
                break;
            case 3:
                visitModelDetailId = "SMART_CONSULT-LABOR";
                visitModelDetailName = "法律机器人问答-劳动争议";
                break;
            case 4:
                visitModelDetailId = "SMART_CONSULT-CONTRACT";
                visitModelDetailName = "法律机器人问答-合同纠纷";
                break;
            case 6:
                visitModelDetailId = "SMART_CONSULT-CRIMINAL";
                visitModelDetailName = "法律机器人问答-刑事犯罪";
                break;
            case 5:
                visitModelDetailId = "SMART_CONSULT-HOUSE";
                visitModelDetailName = "法律机器人问答-房产纠纷";
                break;
            case 7:
                visitModelDetailId = "SMART_CONSULT-PRIVATE_LEND";
                visitModelDetailName = "法律机器人问答-民间借贷";
                break;
            case 111:
                visitModelDetailId = "SMART_CONSULT-PARTY_LEARN";
                visitModelDetailName = "法律机器人问答-党建学习";
                break;
            case 61:
                visitModelDetailId = "SMART_CONSULT-PARTY_LEARN";
                visitModelDetailName = "法律机器人问答-党建学习";
                break;
            default:
                visitModelDetailId = "SMART_CONSULT";
                visitModelDetailName = "法律机器人问答";
                break;
        }
        window.NewLog._saveLog(visitModelDetailId, visitModelDetailName, "", "", c);
    },
    cancelAlert: function () {
        this.data.set('showAlert', false);
    },
    clickDisp: function (e) {
        var ages = e.target || e.srcElement;
        var action = ages.getAttribute("data-action");
        if (action == 'extra') {
            this.goRgzx();
        }
        if (action == 'extra2') {
            this.goLyzx();
        }
        else if (action == 'keyword') {
            var id = ages.getAttribute("data-id");
            var self = this;
            self.data.set('showAlert', true);
            san.nextTick(function () {
                self.data.set('keyword', self.data.get('keywordMap[' + id + ']'));
            });
        }
        else if (action == 'option') {
            var apiQuestion = ages.getAttribute("data-index");
            var displayQuestion = ages.getAttribute("data-q");
            this.createDom(displayQuestion, apiQuestion);
        }
        else if (action == 'link' && domain.indexOf('nx.shiduai.com') === -1) {
            var c = ages.getAttribute("data-go");
            if (c == 'C1') {
                // 工伤赔偿计算
                this.dispatch('accident', 12);
            }
            else if (c == 'C2') {
                this.dispatch('accident', 11);
            }
        }
        else if (action == 'switch') {
            this.data.set('businessType', ages.getAttribute("data-go").replace("{", "").replace("}", ""));
            this.initType(this.data.get('businessType'),2);
            this.dispatch('switchChild', this.data.get('businessType'));
            this.createDom(ages.getAttribute("data-q"));
        }
        else if (action == 'return') {
            var question = ages.innerText;
            this.createDom(question);
        }
        else if (action == 'getType') {
            var me = this;
            Api("post","/api/ask/v2/typeQuestion",JSON.stringify({type: this.data.get('businessType')})).then(function(response){
                if (response) {
                    me.createDom(response.question);
                }
            });
        }
        else if (action == 'addAnswer') {
            var question = ages.innerText;
            var answer = ages.getAttribute("data-answer");
            this.addLocalDom(question, answer);
        }
    },
    smoothScroll2LastQ: function () {
        san.nextTick(function () {
            var questions = document.getElementsByClassName('askQuestion');
            var lastQuestion = questions[questions.length - 1];
            if (!!lastQuestion) {
                var top = lastQuestion.offsetTop;
                var dialogContent = document.getElementById('dialogContent');
                window.Tool._scroll(dialogContent, top - 20)
            }
        });
    },
    createCase: function(id){
        this.dispatch("qjzxanswer2", id);
    },
    smoothScroll: function(ask){
        var askLegal = document.getElementsByClassName(ask);
        var top = askLegal[askLegal.length - 1].offsetTop;
        var dialogContent = document.getElementById('dialogContent');
        san.nextTick(function () {
            window.Tool._scroll(dialogContent, top - 20)
        });
    },
    similarSwitch: function (item) {
        this.smoothScroll('ask-legal');
        if(item.legalBasis && item.caseList){
            return;
        }
        if(item.legalBasis){
            item.showFlag=1;
        }
        if(item.caseList){
            item.showFlag=2;
        }
        item.close = !item.close;
        this.data.set('item.showFlag', item.showFlag);
        this.data.set('item.close', item.close);
    },
    dianzan: function(elv, item, index){
        if(item.evaluateState != elv){
            this.data.set('asks['+index+'].evaluateState', elv);
        }else{
            this.data.set('asks['+index+'].evaluateState', 0);
        }
        var req ={
            logId: item.logId,
            evaluateState: item.evaluateState
        };
        Api("post","/api/ask/v2/evaluate",JSON.stringify(req)).then(function(response){

        });
    },
    askHot: function (question, index) {
        var req = {
            question: question,
            businessType: this.data.get('businessType'),
            sourceType: 2,
            // sourceUserId: localStorage.sysUserId // 使用用户id
            srcClientType: 'WEB_12348',
            sourceUserId: localStorage.sysUserId // 使用用户id
        };
        if (req.businessType == -1) {
            req.fromDialog = "ALL_IN_ONE";
        }
        var me = this;
        Api("post","/api/ask/v2/new",JSON.stringify(req)).then(function(response){
            if (response) {
                me.createDom(response.question);
                me.data.set('dialogWait', false);
                if (response.code == 0) {
                    var ans = domain.indexOf('nx.shiduai.com') > -1 ? response.resp.answer.split(
                        "<br><em data-action='link' data-go="
                      )[0] : response.resp.answer
                    console.log(12345679, domain, domain.indexOf('nx.shiduai.com') === -1, ans, response.resp.answer)
                    var ask = {
                        question: me.data.get('asks')[index].question,
                        answer: ans,
                        logId: response.resp.logId,
                        legalBasis: response.resp.legalBasis,
                        caseList: response.resp.caseList,
                        options: response.resp.options,
                        title: response.resp.title,
                        similar: response.resp.similar,
                        close: true,
                        showFlag: 0,
                        evaluateState: 0,
                        similarClose: false,
                        intelligence:true
                    };
                    if(!!response.resp.legalBasis && !!response.resp.caseList){
                        ask.close = false;
                    }
                    // 相似问题最多5个
                    if (ask.similar) {
                        ask.similar = ask.similar.slice(0, 5);
                    }
                    if (!response.resp.answerId && !!me.data.get("Artificial")) {
                        var extra = '或者你还可以' + '<em data-action="extra">咨询在线工作人员</em>' + '或' + '<em data-action="extra2">留言咨询</em>';
                        ask.answer += extra;
                        ask.intelligence = false
                    }
                    me.data.set('asks[' + index + ']', ask);
                    if (response.keywordList) {
                        response.keywordList.forEach(function (item) {
                            me.data.set('keywordMap[' + [item.id] + ']', item);
                        })
                    }
                    me.saveInfo(response.resp.businessType, "ASK");
                } else {
                    var ask = {
                        question: me.data.get('asks')[index].question,
                        answer: me.data.get('headerTip')["3_2"],
                        close: true,
                        similarClose: false
                    };
                    me.data.set('asks[' + index + ']', ask);
                }
                me.smoothScroll2LastQ();
            }
        }).catch(function (err) {
            me.data.set('dialogWait', false);
            var ask = {
                question: me.data.get('asks')[index].question,
                answer: me.data.get('headerTip')["3_2"],
                close: true,
                similarClose:false
            };
            me.data.set('asks['+index+']', ask);
        });
    },
    setFlag: function(t,index){
        if(this.data.get('asks['+index+'].showFlag')!=t){
            this.data.set('asks['+index+'].showFlag', t);
        }else{
            this.data.set('asks['+index+'].showFlag', 0);
        }
    },
    sendTextQuestion: function () {
        var textarea = $('.textarea')[0];
        this.data.set('question', textarea.innerText.replace(/^\s\s*/, '').replace(/\s\s*$/, ''));
        if (!this.data.get('question')) {
            return;
        }
        this.data.set('question', this.data.get('question').replace(/^\s\s*/, '').replace(/\s\s*$/, ''));
        this.createDom(this.data.get('question'));
        this.data.set('question', "");
        textarea.innerText = "";
    },
    createDom: function (displayQuestion, apiQuestion) {
        if (this.data.get("ifArtificial") == true) {
            this.sendMessage(this.data.get('account'), displayQuestion);
            this.data.set('cont', this.data.get('cont') + 1);
            var ask = {
                question: displayQuestion,
            };
            var index = this.data.get('cont');
            this.data.set('asks[' + index + ']', ask);
            this.smoothScroll2LastQ();
        } else {
            if (displayQuestion == '' || displayQuestion == undefined) {
                return;
            }
            this.data.push('asks', {question: displayQuestion});
            this.data.set('dialogWait', true);
            this.data.set('cont', this.data.get('cont') + 1);
            if (apiQuestion) {
                this.askHot(apiQuestion, this.data.get('cont'));
                return;
            }
            this.askHot(displayQuestion, this.data.get('cont'));
        }
    },
    addLocalDom: function (question, answer) {
        this.data.push('asks',
            {
                question: question,
                answer: answer
            });
        this.data.set('cont', this.data.get('cont') + 1);
        this.smoothScroll2LastQ();
    },
    switchType: function (t) {
        this.initType(t,2);
        this.dispatch('switchChild', t);
    },
    backZnzx: function () {
        this.logout();
        var ask = {
            answer: "你好！已返回智能咨询"
        };
        this.data.set('cont', this.data.get('cont') + 1);
        var index = this.data.get('cont');
        this.data.set('asks[' + index + ']', ask);
        this.smoothScroll2LastQ();
        this.data.set('ifArtificial', false);
    },
    goRgzx: function () {
        if(this.data.get('IEVersion') == -1){
            this.login(localAccount);
            this.data.set('ifArtificial', true);
            var ask = {
                answer: "你好！我是法网驻场人员，请描述你要咨询的问题",
            };
            this.data.set('cont', this.data.get('cont') + 1);
            var index = this.data.get('cont');
            this.data.set('asks[' + index + ']', ask);
            this.smoothScroll2LastQ();
        }else {
            var ask = {
                answer: "你好！该功能暂不支持IE浏览器和360浏览器兼容模式！",
            };
            this.data.set('cont', this.data.get('cont') + 1);
            var index = this.data.get('cont');
            this.data.set('asks[' + index + ']', ask);
            this.smoothScroll2LastQ();
        }
    },
    goLyzx: function () {
        window.open('http://nx.12348.gov.cn/flfw-xt/views/new_front/advice/adviceMsg.jsp');
    }
});



//////////////////
// WEBPACK FOOTER
// ./src/components/ask.js
// module id = 347
// module chunks = 1